export const APPLICATION_LEAGUE_COLLECTION = 'basvuru_lig';
export const NEWS_COLLECTION = 'haber';
export const TRAINING_CATEGORY_COLLECTION = 'antrenman_kategori';
export const TRAINING_COLLECTION = 'antrenman';
export const STATISTIC_COLLECTION = 'istatistik';
export const CLUB_COLLECTION = 'klup';
export const COURT_COLLECTION = 'kort';
export const COURT_AVAILABILITY_COLLECTION = 'kort_musaitlik';
export const USERS_COLLECTION = 'kullanici';
export const USER_AVAILABILITY_COLLECTION = 'kullanici_musaitlik';
export const USER_PRIZE_COLLECTION = 'kullanici_odul';
export const LEAGUES_COLLECTION = 'lig_temel';
export const MATCH_STATUS_RESULT = 'mac_durum_sonuc';
export const PRIZES_COLLECTION = 'odul';
export const PACKETS_COLLECTION = 'paketler';
export const TOURNAMENT_COLLECTION = 'turnuva';
export const TOURNAMENT_PARTICIPATE_COLLECTION = 'turnuva_katilim';
export const TOURNAMENT_GAME_COLLECTION = 'turnuva_oyun';
export const TOURNAMENT_EVENT_COLLECTION = 'turnuva_kategori';
export const SPONSOR_PARTNER_COLLECTION = 'sponsor_partner';
export const COACH_COLLECTION = 'antrenor';
export const SLIDER_COLLECTION = 'slider';
export const NEWS_CACHE_COLLECTION = 'haber_cache';

// Çiftler ligi (paralel sistem) — mobile bu koleksiyonları bilmez
export const DOUBLES_LEAGUE_COLLECTION = 'lig_cift';
export const DOUBLES_TEAM_COLLECTION = 'lig_cift_takim';
export const MAIL_QUEUE_COLLECTION = 'mail_queue';
// Sunucunun yazdığı push olayları (tenis.io-functions notificationPush teslim eder; uid = profil kimliği).
export const PUSH_QUEUE_COLLECTION = 'push_queue';
export const DOUBLES_APPLICATION_COLLECTION = 'basvuru_lig_cift';
export const DOUBLES_MATCH_COLLECTION = 'mac_durum_sonuc_cift';

// Sosyal sistem
export const USER_FOLLOW_COLLECTION = 'kullanici_takip';

// Business ligi (paralel sistem) — mobile bu koleksiyonları bilmez
export const BUSINESS_LEAGUE_COLLECTION = 'lig_business';
export const BUSINESS_LEAGUE_SQUAD_COLLECTION = 'lig_business_ekip';
export const BUSINESS_LEAGUE_PLAYER_COLLECTION = 'lig_business_oyuncu';
export const BUSINESS_MATCHUP_COLLECTION = 'mac_business';

// Tekler ligi akışı: olayları yalnız Functions yazar; `tebrik` alt koleksiyonuna kullanıcı yazar.
export const LEAGUE_FEED_COLLECTION = 'lig_akis';
export const LEAGUE_FEED_CONGRATS_COLLECTION = 'tebrik';
// B1 (akış araştırması §13): bugünkü maça "İyi şanslar" desteği; yalnız sunucu (web API) yazar.
export const MATCH_CHEERS_COLLECTION = 'lig_mac_destek';
// Server-only metadata for private singles match photos (never store image bytes here).
export const LEAGUE_MATCH_PHOTO_COLLECTION = 'lig_mac_fotolari';
// Tekler maç notu (oyuncu başına tek not) ve şikâyetleri; yalnız sunucu (API route) yazar ve okur.
export const LEAGUE_MATCH_NOTE_COLLECTION = 'lig_mac_notlari';
export const LEAGUE_MATCH_NOTE_REPORT_COLLECTION = 'lig_mac_not_sikayetleri';
// Rakipten fotoğraf/not isteği (LG-64): maç + isteyen + tür başına tek kayıt; yalnız sunucu yazar.
export const LEAGUE_MATCH_REQUEST_COLLECTION = 'lig_mac_istekleri';
// Akış gönderisi (kullanıcı paylaşımı): kamusal kart `lig_akis/{gonderi_*}`; yazan, fotoğraf yolu,
// şikâyet ve günlük sayaç yalnız sunucunun okuduğu bu koleksiyonlarda.
export const FEED_POST_COLLECTION = 'akis_gonderileri';
export const FEED_POST_REPORT_COLLECTION = 'akis_gonderi_sikayetleri';
export const FEED_POST_QUOTA_COLLECTION = 'akis_gonderi_sayac';
// LG-61 kulüp duyurusu: kamusal kartlar `lig_akis/{duyuru_<id>_<lig>}`; taslak, revizyon geçmişi ve
// şikâyetler yalnız sunucunun okuduğu bu koleksiyonlarda.
export const CLUB_ANNOUNCEMENT_COLLECTION = 'kulup_duyurulari';
export const CLUB_ANNOUNCEMENT_REPORT_COLLECTION = 'kulup_duyuru_sikayetleri';
